export const HttpRequestHeaders = {
  DASHBOARD_PLATFORM_ID: 'new-dashboard',
};
